import { useState } from "react";
import { Button, Input } from "antd";
import "./set_password.css";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { SuccessToast } from "../../widgets/AppToast";
import { post } from "../../services/services";
import { ApiURL } from "../../services/apiConstants";

const SetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});

  // Set Password API
  const addPassword = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("email", email);
    formData.append("new_password", password);
    formData.append("confirm_password", passwordConfirmation);
    try {
      const res = await post(ApiURL.password_reset, formData);
      if (res?.status === true) {
        SuccessToast("Success!!", "Set Password Successfully");
        navigate("/");
      } else {
        setErrors(res?.errors || {});
      }
    } catch (error) {
      setErrors({ catch: ["An error occurred. Please try again."] });
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="password-page">
      <div className="password-box">
        <div className="password-box-head">
          <h5>MarinBytes - Admin Portal</h5>
          <h2>Forget Password</h2>
        </div>
        <div className="login-box-body">
          {errors?.try && <span style={{ color: "red" }}>{errors.try[0]}</span>}
          {errors?.catch && (
            <span style={{ color: "red" }}>{errors.catch[0]}</span>
          )}
          <div className="input-box">
            <label>Email</label>
            <Input
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="off"
            />
            {errors?.email && (
              <span style={{ color: "red" }}>{errors.email}</span>
            )}
          </div>
          {/* New Password */}
          <div className="input-box">
            <label>Password</label>
            <Input.Password
              placeholder="Set Password"
              onChange={(e) => setPassword(e.target.value)}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
            {errors?.new_password && (
              <span style={{ color: "red" }}>{errors.new_password}</span>
            )}
          </div>
          {/* Confirm Password */}
          <div className="input-box">
            <label>Confirm Password</label>
            <Input.Password
              placeholder="Confirm Password"
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
            {errors?.confirm_password && (
              <span style={{ color: "red" }}>{errors.confirm_password}</span>
            )}
            {errors?.password && (
              <span style={{ color: "red" }}>{errors.password}</span>
            )}
          </div>
          <div className="input-box" style={{ textAlign: "center" }}>
            <Button type="primary" onClick={addPassword} loading={loader}>
              Forget Password
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
